// ** Icon imports
import Dashboard from 'src/assets/Dashboard.svg'
import Services from 'src/assets/My-Services.svg'
import Quote from 'src/assets/Quote-Requests.svg'
import Store from 'src/assets/storeupfrount.svg'
import TeamManagement from 'src/assets/team-management.png'
import Payment from 'src/assets/Payments.svg'
import AddressBook from 'src/assets/AddressBook.svg'
import Protection from 'src/assets/Oujat-Protection.svg'
import Dispute from 'src/assets/Dispute-Center.svg'
import NotificationsIcon from '@mui/icons-material/Notifications'
import ChatIcon from 'src/@core/components/icons/chatIcon'
import NotificationIcon from 'src/@core/components/icons/NotificationIcon'
import OrdersManagementIcon from 'src/@core/components/icons/OrdersManagementIcon'
import BadgeIcon from '@mui/icons-material/MilitaryTech'

const navigation = t => {
  return [
    {
      id: 'dashboard',
      title: t('SideMenu Data.Dashboard'),
      icon: Dashboard,
      path: '/dashboard'
    },
    {
      id: 'my_services',
      title: t('SideMenu Data.My Services'),
      icon: Services,
      path: '/service'
    },
    {
      id: 'quotes_management',
      title: t('SideMenu Data.Quotes Management'),
      icon: Quote,
      path: '/my-qms'
    },
    // {
    //   title: 'Open Quote Requests',
    //   icon: Quote,
    //   path: '/open-quote'
    // },
    {
      id: 'storefront',
      title: t('SideMenu Data.Storefront'),
      icon: Store,
      path: '/store-front'
    },
    {
      id: 'team_management',
      title: t('SideMenu Data.Team Management'),
      icon: TeamManagement,
      path: '/team-management'
    },
    {
      id: 'orders',
      title: t('SideMenu Data.Orders'),
      icon: OrdersManagementIcon,
      path: '/order'
    },
    {
      id: 'payments',
      title: t('SideMenu Data.Payments'),
      icon: Payment,
      path: '/payments'
    },
    {
      id: 'subscriptions',
      title: t('SideMenu Data.Subscriptions'),
      icon: Payment,
      path: '/subscriptions'
    },
    {
      id: 'main_chat',
      title: t('SideMenu Data.Main Chat'),
      icon: ChatIcon,
      path: '/chat'
    },
    // {
    //   title: 'My Wallet',
    //   icon: Quote
    //   // path: '/my-wallet '
    // },
    // {
    //   title: 'Payments',
    //   icon: Payments
    //   // path: '/Payments'
    // },
    {
      id: 'oujat_protection',
      title: t('SideMenu Data.Oujat Protection'),
      icon: Protection,
      path: '/oujat-protection'
    },
    {
      id: 'dispute_center',
      title: t('SideMenu Data.Dispute Center'),
      icon: Dispute,
      path: '/dispute-center'
    },
    {
      id: 'address_book',
      title: t('SideMenu Data.Address Book'),
      icon: AddressBook,
      path: '/address-book'
    },
    {
      id: 'badge_management',
      title: t('SideMenu Data.Badge Management'),
      icon: BadgeIcon,
      path: '/badge-management'
    }
    // {
    //   title: 'Notifications',
    //   icon: NotificationIcon,
    //   path: '/notification'
    // }
    // {
    //   title: 'Analytics/Reports ',
    //   icon: Analytics
    //   // path: '/analytics'
    // },
    // {
    //   title: 'Settings',
    //   icon: Setting
    //   // path: '/settings'
    // }
  ]
}

export default navigation
